export const MAIN_BACKGROUND_COLOR = "#FBB438";
export const fontColor = "white";



